import React from 'react';
import about from './img/about.png';

const HomeAboutsec = () => {
	return (
		<div>
			<div className="w-full py-20 bg-slate-100 flex justify-center mt-10 max-[480px]:mt-0  max-[480px]:py-10">
				<div className="max-w-[1240px] grid col-start-2 md:grid-cols-2 sm:grid-cols-1">
					<div className="flex justify-center mt-5">
						<img
							className="w-90 max-[480px]:w-80 max-[480px]:text-6xl object-fill border-8 border-white shadow-2xl shadow-slate-800"
							src={about}
							alt=""
						/>
					</div>
					<div className=" flex-col mt-5">
						<h1 className="text-8xl text-normal font-bold text-cyan-700 max-[480px]:text-center max-[480px]:text-6xl capitalize">Welcome To</h1>
						<h1 className="text-2xl text-normal pl-2 font-semibold capitalize max-[480px]:text-center max-[480px]:text-2xl">
							Al Talib Shipping Company
						</h1>
						<p className="text-base text-normal pt-10 px-10 leading-10 text-left">
							Al Talib Shipping Co. LLC is a fully integrated logistics company founded in 1993 in the
							UAE. It is headquartered in Dubai and has offices in Ras Al Khor and Jebel Ali Free Zone,
							UAE. We also have operations in Qatar, Bahrain, and Oman. Today Al Talib Shipping is a
							reputed full-service domestic and international freight forwarder that offers fast, reliable
							and responsive customer service that is cost effective and dependable.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HomeAboutsec;
